import React, { useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateCategory = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await api.post("/admin/categories", { name });
      toast.success("Catégorie créée avec succès !");
      navigate("/dashboard/categories");
    } catch (err) {
      console.error(err);
      const message =
        err.response?.data?.message ||
        err.response?.data?.title ||
        "Erreur lors de la création de la catégorie";
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-10 text-slate-100">
      <div className="mx-auto max-w-4xl">
        <section className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-green-900 text-white shadow-sm">
          <div className="p-8 md:p-10">
            <p className="mb-3 inline-flex rounded-full bg-white/10 px-3 py-1 text-sm font-medium text-green-100">
              Dashboard catégories
            </p>
            <h1 className="mb-3 text-3xl font-bold md:text-4xl">
              Créer une catégorie
            </h1>
            <p className="max-w-2xl text-sm leading-7 text-slate-200 md:text-base">
              Ajoutez une nouvelle catégorie pour organiser vos contenus et
              structurer plus facilement les posts du site.
            </p>
          </div>
        </section>

        <section className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm">
          {error && (
            <div className="mb-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="rounded-2xl border border-slate-800 bg-slate-950 p-6">
              <h2 className="mb-5 text-lg font-semibold text-white">
                Informations de la catégorie
              </h2>
              <div>
                <label htmlFor="name" className="mb-2 block text-sm font-medium text-slate-200">
                  Nom de la catégorie
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder="Ex : Mariage, Portrait, Urbain..."
                  className="block w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-slate-100 placeholder:text-slate-500 focus:border-green-500 focus:outline-none"
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-xl bg-green-600 px-6 py-3 font-semibold text-white transition hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
              >
                {loading ? "Création..." : "Créer"}
              </button>
              <button
                type="button"
                onClick={() => navigate("/dashboard/categories")}
                className="w-full rounded-xl border border-slate-700 px-6 py-3 font-semibold text-slate-200 transition hover:bg-slate-800 sm:w-auto"
              >
                Annuler
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default CreateCategory;